// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6 2H18V4H17V8H23V22H13V15H11V22H1V8H7V4H6V2ZM3 20H7V10H3V20ZM21 10H17V20H21V10ZM13.0039 5.99805H11V8.00195H13.0039V5.99805Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-13-filled')
export default class City13FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-13-filled',
    }
  }
}
